import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from '@mui/material';
import React from 'react';

// NLA/CredSSP needs credentials before the desktop renders, so we collect them
// up front. Username is pre-filled from the client user assignment when known.
const RdpCredentialsDialog = ({ open, defaultUsername, onCancel, onSubmit }) => {
  const [username, setUsername] = React.useState(defaultUsername || '');
  const [password, setPassword] = React.useState('');

  React.useEffect(() => {
    if (open) {
      setUsername(defaultUsername || '');
      setPassword('');
    }
  }, [open, defaultUsername]);

  const handleSubmit = e => {
    e.preventDefault();
    onSubmit({ username, password });
  };

  return (
    <Dialog open={open} onClose={onCancel} maxWidth="xs" fullWidth>
      <form onSubmit={handleSubmit}>
        <DialogTitle>Connect via RDP</DialogTitle>
        <DialogContent
          sx={{ display: 'flex', flexDirection: 'column', gap: 2, pt: 1 }}
        >
          <TextField
            label="Username"
            value={username}
            onChange={e => setUsername(e.target.value)}
            autoFocus
            fullWidth
            size="small"
          />
          <TextField
            label="Password"
            type="password"
            value={password}
            onChange={e => setPassword(e.target.value)}
            fullWidth
            size="small"
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={onCancel}>Cancel</Button>
          <Button type="submit" variant="contained" disabled={!username}>
            Connect
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};

export default RdpCredentialsDialog;
